export enum GroupUser {
    Assistant = 2,
    Supporter = 3,
    Supper_Admin = 10,
    Psychologist = 8,
    Top_Student = 9
}